import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { authHeader, userPermissions } from '../../../utils';
import axios from 'axios';
import { ERROR } from '../../../store/types';
import Loader from '../../elements/Loader';
import moment from 'moment';
import InvoiceStatus from '../../elements/InvoiceStatus';

const AssignedInvoice = ({invoiceId, assignment, closeFunction, startAddDiscount, startEnablePartPayment}) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true);
    const [invoiceDetails, setInvoiceDetails] = useState(null);
    const [invoiceAssignment, setInvoiceAssignment] = useState(assignment)
    // const invoicesSelector = useSelector(state => state.invoices)
  
    useEffect(() => {
      const fetchAssignment = async () => {
        try {
          const headers = authHeader()
  
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/invoice-assignments/${assignment._id}`, { headers })            
  
            setInvoiceAssignment(response.data.data)
            setLoading(false)
            
          } catch (error) {
              console.log(error)
              dispatch({
                  type: ERROR,
                  error
              })
              setLoading(false)
          }
      }

      const fetchInvoice = async () => {
        try {
          const headers = authHeader()
  
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/invoices/${assignment.invoice._id}?expand=fees.fee`, { headers })            
  
            setInvoiceDetails(response.data.data)
            fetchAssignment(false)
            
          } catch (error) {
              console.log(error)
              dispatch({
                  type: ERROR,
                  error
              })
              setLoading(false)
          }
      }
  
      fetchInvoice()
  
  
      return () => {
        
      };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    return (
      <div className='w-full'>
        {loading ? 
          <div className='w-full'>
            <Loader />
          </div>
  
          :
  
          <>
            <div className='py-3 mb-2'>
              <div className="w-full mx-auto">
                <div className='w-full flex items-center justify-between'>
                  <div className='w-2/3'>
                    <h4 className='font-medium text-lg text-gray-400'>Invoice Details</h4>
                    <div className=''>
                      <p className='text-gray-500 mt-1 text-sm'>
                        Below are the details of the invoice.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
      
            <div className='w-full'>
              <div className='flex items-start justify-between'>
                <div className='w-full mb-[10px]'>
                  <p className='text-xs text-gray-400 mb-[5px]'>Name</p>
                  <h3 className='font-[500] text-black text-lg'>{invoiceDetails.name}</h3>

                  <div className='mt-[20px]'>
                    <p className='text-xs text-gray-400 mb-[5px]'>Description</p>
                    <p className='font-[500] text-sm text-black'>{invoiceDetails.description}</p>
                  </div>

                  <div className='w-full mt-[20px] mb-[10px]'>
                    <p className='text-xs text-gray-400 mb-[5px]'>Invoice Total</p>
                    <h3 className='font-[500] text-black text-4xl'>₦{(invoiceAssignment.discountedTotal/100).toLocaleString()}</h3>
                    
                    {invoiceAssignment?.discount?.confirmed && <p className='p-[10px] bg-green-500 bg-opacity-5 w-[80%] rounded mt-[10px] text-green-800 text-xs'><span className='font-space-grotesk font-[500] text-sm'>Discount applied</span><br/><span className='inline-block mt-[5px]'>{assignment?.discount?.description}</span></p>}
                    {invoiceAssignment?.partPayments?.confirmed && <p className='p-[10px] bg-blue-500 bg-opacity-5 w-[80%] rounded mt-[10px] text-blue-800 text-xs'><span className='font-space-grotesk font-[500] text-sm'>Part payments allowed</span><br/><span className='inline-block mt-[5px]'>{invoiceAssignment.partPayments?.description}</span><br />
                    Max Installments: <span className='font-[550]'>{invoiceAssignment.partPayments?.totalPayments}</span><br />
                    Minimum Amount: <span className='font-[550]'>₦{invoiceAssignment.partPayments?.minimumAmount?.toLocaleString()}</span>
                    </p>}

                    {invoiceAssignment.sundry?.transactions?.length > 0 && <p className='text-sm text-gray-500'>This invoice amount includes sundry transactions totalling <span className='font-[600] font-space-grotesk text-lg text-black'>₦{(assignment.sundry.total/100).toLocaleString()}</span> from <span className='text-black font-[600]'>{moment(assignment.sundry.dateFrom).format('LL')} to {moment(assignment.sundry.dateTo).format('LL')}</span></p>}
                </div>
                </div>
                <div className='w-full mb-[10px]'>
                  <div className=''>
                    <p className='text-xs text-gray-400 mb-[5px]'>Invoice Code</p>
                    <p className='font-[500] text-xl font-space-grotesk text-black'>{invoiceDetails.invoiceCode}</p>
                  </div>
                  <div className='mt-[20px]'>
                    <p className='text-xs text-gray-400 mb-[5px]'>Payment Status</p>
                    {/* <p className='font-[500] text-xl font-space-grotesk text-black'>{invoiceDetails.invoiceCode}</p> */}
                    <InvoiceStatus status={invoiceAssignment.status} />
                  </div>

                  <div className='mt-[20px]'>
                    <p className='text-xs text-gray-400 mb-[5px]'>Payment Date</p>
                    {invoiceAssignment.paymentDate && invoiceAssignment.paymentDate !== null ? <p className='text-sm'>{moment(assignment.paymentDate).format('LL')} - {moment(assignment.paymentDate).format('hh:mm a')}</p> : <div className='h-[15px] w-[150px] bg-gray-100 animate-pulse' />}
                  </div>

                  <div className='mt-[20px]'>
                    <p className='text-xs text-gray-400 mb-[5px]'>Payment Deadline</p>
                    <p className='text-sm'>{moment(invoiceAssignment.paymentDeadline).format('LL')}</p>
                  </div>
                  
                  {/* <div className='mt-[10px]'>
                    <p className='text-xs text-gray-400 mb-[5px]'>Description</p>
                    <p className='font-[500] text-sm text-black'>{invoiceDetails.description}</p>
                  </div> */}
                </div>
              </div>

              <div className='w-full pt-[20px] border-t mt-[20px]'>
                <div className='w-full mb-[10px]'>
                  <h3 className='text-gray-600 mb-[5px] font-[550]'>Fees (all fees that make up this invoice)</h3>

                  <div className='w-full mt-[20px] flex items-center justify-between mb-[10px] p-[5px] bg-gray-100'>
                    <div className='w-6/12'>
                      <p className='text-xs text-gray-400 mb-[5px]'>Fee</p>
                    </div>
                    <div className='w-3/12'>
                      <p className='text-xs text-gray-400 mb-[5px] text-right'>Rate</p>
                    </div>
                    <div className='w-1/12'>
                      <p className='text-xs text-gray-400 mb-[5px] text-right'>Quantity</p>
                    </div>
                    <div className='w-2/12'>
                      <p className='text-xs text-gray-400 mb-[5px] text-right'>Subtotal</p>
                    </div>
                  </div>
                  {invoiceDetails.fees.map((fee, feeIndex)=>(<div key={feeIndex} className='w-full mt-[20px] flex items-start justify-between p-[5px] gap-x-[10px] border-b'>
                    <div className='w-6/12'>
                      <p className='text-gray-700 mb-[5px]'>{fee.fee.name}</p>
                      <p className='text-gray-500 text-sm mb-[5px]'>{fee.fee.description}</p>
                    </div>
                    <div className='w-3/12'>
                      <p className='text-gray-700 font-space-grotesk font-[500] mb-[5px] text-right'>{(fee.fee.amount/100).toLocaleString()}</p>
                    </div>
                    <div className='w-1/12'>
                      <p className='text-gray-700 mb-[5px] text-right'>{fee.quantity}</p>
                    </div>
                    <div className='w-2/12'>
                      <p className='text-gray-700 font-space-grotesk font-[500] mb-[5px] text-right'>₦{((fee.fee.amount/100) * fee.quantity).toLocaleString()}</p>
                    </div>
                  </div>))}
                </div>
              </div>

              {invoiceAssignment.sundry?.transactions?.length > 0 && <div className='w-full p-[20px] bg-gray-50 rounded-[8px] mt-[40px]'>
                <div className='w-full mb-[10px]'>
                  <h3 className='text-gray-600 mb-[5px] font-[550]'>Sundry Transactions in this invoice</h3>

                  <div className='w-full mt-[20px] flex items-center justify-between mb-[10px] p-[5px] bg-gray-100'>
                    <div className='w-6/12'>
                      <p className='text-xs text-gray-400 mb-[5px]'>Reference</p>
                    </div>
                    <div className='w-3/12'>
                      <p className='text-xs text-gray-400 mb-[5px]'>Date</p>
                    </div>
                    <div className='w-1/12'>
                      <p className='text-xs text-gray-400 mb-[5px]'>Items</p>
                    </div>
                    <div className='w-2/12'>
                      <p className='text-xs text-gray-400 mb-[5px] text-right'>Amount</p>
                    </div>
                  </div>
                  {invoiceAssignment.sundry?.transactions?.map((transaction, transactionIndex)=>(<div key={transactionIndex} className='w-full mt-[20px] flex items-start justify-between p-[5px] gap-x-[10px] border-b'>
                    <div className='w-6/12'>
                      <p className='text-gray-700 font-space-grotesk mb-[5px]'>{transaction.reference}</p>
                      {/* <p className='text-gray-500 text-sm mb-[5px]'>{fee.fee.description}</p> */}
                    </div>
                    <div className='w-3/12'>
                      <p className='text-gray-700 font-[500] mb-[5px] text-sm'>{moment(transaction.createdAt).format('MMMM Do YYYY, h:mm a')}</p>
                    </div>
                    <div className='w-1/12'>
                      <p className='text-gray-700 mb-[5px] text-sm'>{transaction.items?.length} item(s)</p>
                    </div>
                    <div className='w-2/12 text-right'>
                      <p className='text-gray-700 font-space-grotesk font-[500] mb-[5px]'>₦{(transaction.amount/100).toLocaleString()}</p>
                    </div>
                  </div>))}
                </div>
              </div>
              }

              {invoiceAssignment.status === 'PENDING' && <div className='w-full my-[20px]'>
                {userPermissions().includes('invoices.enable-part-payments') && !invoiceAssignment?.partPayments?.confirmed &&
                  <div className='mb-[10px] w-full flex items-center justify-between gap-x-2 bg-gray-50 p-[10px] border border-gray-300 rounded-[8px]'>
                    <div className='w-full'>
                      <h3 className='font-space-grotesk text-[15px] font-medium'>Part Payments</h3>
                      <p className='text-[13px] text-gray-600'>You can allow the assignee to split payments for this invoice by clicking on the "Enable Part Payments" button.</p>
                    </div>
                    <div className='flex flex-row-reverse w-[40%]'>
                      <button onClick={()=>startEnablePartPayment(assignment)} className='bg-black rounded-[8px] font-space-grotesk text-[13px] font-medum text-vcm-light-purple transiton duraton-200 hover:bg-gray-800 px-[12px] py-[10px]'>Enable Part Payments</button>
                    </div>
                  </div>
                }

                {userPermissions().includes('invoices.add-discount') && !invoiceAssignment?.discount?.confirmed && 
                  <div className='mb-[10px] w-full flex items-center justify-between gap-x-2 bg-gray-50 p-[10px] border border-gray-300 rounded-[8px]'>
                    <div className='w-full'>
                      <h3 className='font-space-grotesk text-[15px] font-medium'>Discount</h3>
                      <p className='text-[13px] text-gray-600'>You can add a discount for this invoice assignment by clicking on the "Discount this Invoice" button.</p>
                    </div>
                    <div className='flex flex-row-reverse w-[40%]'>
                      <button onClick={()=>startAddDiscount(assignment)} className='bg-black rounded-[8px] font-space-grotesk text-[13px] font-medum text-vcm-light-purple transiton duraton-200 hover:bg-gray-800 px-[12px] py-[10px]'>Discount this incvoice</button>
                    </div>
                  </div>
                }
              </div>}

            </div>
          </>
  
        }

        <div className="mt-8 flex flex-row-reverse gap-x-4">
          <button
            type="button"
            className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-lg transition duration-200 hover:bg-opacity-10 hover:bg-secondary focus:outline-none"
            onClick={closeFunction}
          >
            Close
          </button>
        </div>
      </div>
    )
  }
export default AssignedInvoice